import { LOGO_URL } from "@/lib/format";

export default function Maintenance() {
  return (
    <div
      data-testid="maintenance-page"
      className="min-h-screen flex flex-col items-center justify-center px-6 text-center bg-[#0b0f0c] text-white"
    >
      <img
        src={LOGO_URL}
        alt="Bilanga Congo"
        data-testid="maintenance-logo"
        className="w-40 sm:w-52 mb-10 rounded-md"
      />
      <h1 data-testid="maintenance-title" className="text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight">
        Work in progress
      </h1>
      <p data-testid="maintenance-message" className="mt-6 max-w-md text-sm sm:text-base text-white/60">
        Our website is currently under construction. Please check back soon.
      </p>
    </div>
  );
}
